var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 290586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path372",
    d: "M15.0934 7.97434C15.0934 11.9017 11.9359 15.0854 8.04086 15.0854C4.14576 15.0854 0.988281 11.9017 0.988281 7.97434C0.988281 4.04691 4.14576 0.863228 8.04086 0.863228C11.9359 0.863228 15.0934 4.04691 15.0934 7.97434Z",
    stroke: "#2D3958",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    d: "M10.8608 7.02616C10.8608 8.5971 9.59788 9.87061 8.03981 9.87061C6.48169 9.87061 5.21875 8.5971 5.21875 7.02616C5.21875 5.45525 6.48169 4.18175 8.03981 4.18175C9.59788 4.18175 10.8608 5.45525 10.8608 7.02616Z",
    stroke: "#2D3958",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path380",
    d: "M3.83203 13.6816C4.05766 11.5393 5.85539 9.87056 8.03979 9.87056C10.2242 9.87056 12.022 11.5395 12.2475 13.6816",
    stroke: "#2D3958",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImg);
export default __webpack_public_path__ + "static/media/user-img.d3bce95fff3c33e8926fe11d9d65c339.svg";
export { ForwardRef as ReactComponent };